// NewDatabaseFilterPanel.tsx
import React from 'react';
import './NewDatabaseFilterPanel.css';

interface NewDatabaseFilterPanelProps {
    isOpen: boolean;
    onClose: () => void;
    onFiltersChange?: (filters: string[]) => void;
}

const NewDatabaseFilterPanel: React.FC<NewDatabaseFilterPanelProps> = ({ 
    isOpen,
    onClose,
    onFiltersChange,
}) => {
    const [activeFilters, setActiveFilters] = React.useState<string[]>([]);

    const filterOptions = [
        { 
            key: 'short_loads', 
            label: 'Short Loads', 
            description: '< 160 Gross Barrels',
            color: '#ff9800'
        },
        { 
            key: 'negative_profit', 
            label: 'Negative Profit', 
            description: '< $0 Net Profit',
            color: '#f44336'
        },
        { 
            key: 'high_bsw', 
            label: 'High BS&W', 
            description: '> 1%',
            color: '#9c27b0'
        },
    ];

    const handleFilterToggle = (filterKey: string) => {
        const newFilters = activeFilters.includes(filterKey)
            ? activeFilters.filter(f => f !== filterKey)
            : [...activeFilters, filterKey];
        setActiveFilters(newFilters);
        onFiltersChange?.(newFilters);
    };

    const handleClearFilters = () => {
        setActiveFilters([]);
        onFiltersChange?.([]);
    };

    return (
        <>
            <div className={`newdb-filter-panel ${isOpen ? 'open' : ''}`}>
                <div className="newdb-filter-header">
                    <h3>Quick Filters</h3>
                    <button onClick={onClose} className="newdb-filter-close-button">
                        &times;
                    </button>
                </div>
                
                <div className="newdb-filter-content">
                    <div className="newdb-filter-description">
                        Apply quick filters to identify specific load types
                    </div>

                    <div className="newdb-filter-options">
                        {filterOptions.map(option => (
                            <button
                                key={option.key}
                                className={`newdb-filter-card ${activeFilters.includes(option.key) ? 'active' : ''}`}
                                onClick={() => handleFilterToggle(option.key)}
                                style={{
                                    borderColor: activeFilters.includes(option.key) ? option.color : undefined,
                                    backgroundColor: activeFilters.includes(option.key) ? `${option.color}15` : undefined
                                }}
                            >
                                <div className="newdb-filter-card-header">
                                    <input
                                        type="checkbox"
                                        checked={activeFilters.includes(option.key)}
                                        readOnly
                                        style={{ accentColor: option.color }}
                                    />
                                    <span className="newdb-filter-card-title">{option.label}</span>
                                </div>
                                <span className="newdb-filter-card-description">{option.description}</span>
                            </button>
                        ))}
                    </div>

                    {activeFilters.length > 0 && (
                        <div className="newdb-filter-active-summary">
                            <span>{activeFilters.length} filter{activeFilters.length !== 1 ? 's' : ''} active</span>
                        </div>
                    )}

                    <div className="newdb-filter-actions">
                        <button 
                            className="newdb-filter-clear-button"
                            onClick={handleClearFilters}
                            disabled={activeFilters.length === 0}
                        >
                            Clear All Filters
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewDatabaseFilterPanel;
